import { render, staticRenderFns } from "./BucketNew.vue?vue&type=template&id=2348e92c"
import script from "./BucketNew.vue?vue&type=script&lang=js"
export * from "./BucketNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports